module.exports = [{
      plugin: require('/Users/mbokowy/Projekty/Intellect/intellect-site/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/mbokowy/Projekty/Intellect/intellect-site/src/layout/Layout.jsx"},
    },{
      plugin: require('/Users/mbokowy/Projekty/Intellect/intellect-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
